import { render } from "./PedidosZonaView.vue?vue&type=template&id=a982dfd6&scoped=true"
import script from "./PedidosZonaView.vue?vue&type=script&lang=js"
export * from "./PedidosZonaView.vue?vue&type=script&lang=js"

import "./PedidosZonaView.vue?vue&type=style&index=0&id=a982dfd6&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a982dfd6"]])

export default __exports__